module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"what-wall\"-in-inglewood-california-5a36e3c5f7cf2ada9fc53647700e2fec.png";